import DedicatedCreate from './Create'
import DedicatedUpdate from './Update'
import DedicatedDetails from './Details'
import DedicatedGet from './Get'
import DedicatedAllotment from './Allotment'
import DedicatedStakeholders from './Stakeholders'

export {
    DedicatedCreate,
    DedicatedUpdate,
    DedicatedDetails,
    DedicatedGet,
    DedicatedAllotment,
    DedicatedStakeholders,
}